module.exports = __webpack_public_path__ + "static/media/property.ec320a8e.jpg";